import { ITripsTableData } from 'pages/Trips/TripsTable/TripsTable.model';

import * as actions from '../actions/trips';

const initialState: State = {
  selectedTrips: [],
  onQueueAssign: null,
  onQueueRemove: null,
  needsRefetchOnNextManual: {},
};

export const reducer = (state: State = initialState, action: actions.TripsTypes): State => {
  switch (action.type) {
    case actions.TripsActions.SetSeleceted:
      return { ...state, selectedTrips: action.payload.trips };
    case actions.TripsActions.SetOnQueueRemove:
      return { ...state, onQueueRemove: action.payload.callback };
    case actions.TripsActions.SetOnQueueAssign:
      return { ...state, onQueueAssign: action.payload.callback };
    case actions.TripsActions.MarkAutoAssigned: {
      const next = { ...state.needsRefetchOnNextManual };

      for (const id of action.payload.tripIds) {
        next[id] = true;
      }

      return { ...state, needsRefetchOnNextManual: next };
    }

    case actions.TripsActions.ClearAutoAssigned: {
      if (!state.needsRefetchOnNextManual[action.payload.tripId]) {
        return state;
      }

      const next = { ...state.needsRefetchOnNextManual };

      delete next[action.payload.tripId];

      return { ...state, needsRefetchOnNextManual: next };
    }
    default:
      return state;
  }
};

export type State = {
  selectedTrips: ITripsTableData[];
  onQueueAssign: ((jobIds: number[]) => void) | null;
  onQueueRemove: ((jobIds: number[]) => void) | null;
  needsRefetchOnNextManual: Record<number, true>;
};
